"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var utils_1 = require("./utils");
var getTransactionStatus = function (_account, tx) { return __awaiter(void 0, void 0, void 0, function () {
    var commandDescriptor, command, fee, errors, warnings, amount, estimatedFees, totalSpent;
    return __generator(this, function (_a) {
        commandDescriptor = tx.model.commandDescriptor;
        if (commandDescriptor === undefined) {
            return [2 /*return*/, {
                    amount: tx.amount,
                    estimatedFees: new bignumber_js_1.BigNumber(0),
                    totalSpent: tx.amount,
                    errors: {},
                    warnings: {}
                }];
        }
        command = commandDescriptor.command, fee = commandDescriptor.fee, errors = commandDescriptor.errors, warnings = commandDescriptor.warnings;
        amount = new bignumber_js_1.BigNumber(getAmount(command));
        estimatedFees = new bignumber_js_1.BigNumber(fee);
        totalSpent = new bignumber_js_1.BigNumber(getTotalSpent(commandDescriptor));
        return [2 /*return*/, {
                amount: amount,
                estimatedFees: estimatedFees,
                totalSpent: totalSpent,
                warnings: warnings,
                errors: errors
            }];
    });
}); };
function getAmount(command) {
    switch (command.kind) {
        case "transfer":
        case "token.transfer":
        case "stake.createAccount":
        case "stake.withdraw":
            return command.amount;
        case "token.createATA":
        case "stake.delegate":
        case "stake.undelegate":
        case "stake.split":
            return 0;
        default:
            return (0, utils_1.assertUnreachable)(command);
    }
}
function getTotalSpent(_a) {
    var command = _a.command, fee = _a.fee;
    switch (command.kind) {
        case "transfer":
        case "stake.createAccount":
            return command.amount < 0 ? 0 : command.amount + fee;
        case "token.transfer":
            return Math.max(command.amount, 0);
        case "token.createATA":
        case "stake.delegate":
        case "stake.undelegate":
        case "stake.withdraw":
        case "stake.split":
            return fee;
        default:
            return (0, utils_1.assertUnreachable)(command);
    }
}
exports["default"] = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map